import { render, staticRenderFns } from "./ServiceInfoModal.vue?vue&type=template&id=18f5b0b5&"
import script from "./ServiceInfoModal.vue?vue&type=script&lang=js&"
export * from "./ServiceInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports